export default "__VITE_ASSET__BSzOGcrB__"